module.exports = __webpack_public_path__ + "img/KSC03580.4b201b75.jpg";